import React from "react";

const renderRow = (data) => {
  if (!data) {
    return 'Produto não encontrado'
  }
  return data
}

class ProductTypesTabGrid {

  columns = [
    {
      Header: "Id",
      Cell: row => renderRow(row.original.productType && row.original.productType.id)
    },
    {
      Header: "Referência",
      Cell: (row) => renderRow(row.original.productType && row.original.productType.reference && <a onClick={e => e.preventDefault()} href="">{row.original.productType.reference}</a>)
    },
    {
      Header: "Descrição",
      Cell: row => renderRow(row.original.productType && row.original.productType.description)
    },
    {
      Header: "Total de itens",
      Cell: row => row.original.total
    }
  ];

  endpoint = (transactionId) => {
    return `ton/v1/transaction-items/transactions/${transactionId}/product-types`;
  }

}

export default ProductTypesTabGrid;



// WEBPACK FOOTER //
// ./src/customGrid/entities/ProductTypeTabGrid.js